/* unplugin-vue-components disabled */import script from "./alerts.vue?vue&type=script&lang=js"
export * from "./alerts.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__